import React, { useEffect, useMemo, useState } from 'react';
import {
  EuiButtonIcon,
  EuiPopover,
  EuiFlexGroup,
  EuiFlexItem,
  EuiSwitch,
  EuiPanel,
  EuiButton,
  EuiSpacer,
} from '@elastic/eui';

export const ExternalFilterUsers = (props) => {

  const {handleExternalFilter, translate, showNoExpatriados} = props
  const [isPopoverOpen, setPopover] = useState(false);
  const smallContextMenuPopoverId = 'smallContextMenuPopover'
  const [filtros,setFiltros] = useState({noExpatriados:true,expatriadosNoFacturables:true,expatriadosFacturables:true,todos:true})

  useEffect(()=>{handleExternalFilter(filtros)},[])

  const onButtonClick = () => {
    setPopover(!isPopoverOpen);
  };

  const closePopover = () => {
    setPopover(false);
  };

  const onChangeFilter = (newPartFilter)=>{
    let newFilter = {...filtros,...newPartFilter}
    newFilter = (newFilter.noExpatriados===true && newFilter.expatriadosNoFacturables===true && newFilter.expatriadosFacturables===true) ? {...newFilter,...{todos:true}} : {...newFilter,...{todos:false}}
    setFiltros(newFilter)
  }

  const acceptFilter = useMemo(()=>Object.keys(filtros).filter(a => filtros[a]===true).length,[filtros])

  const onSaveFilter = () =>{handleExternalFilter(filtros);closePopover();}

  const getFilterNoExpatriados = ()=> showNoExpatriados ? (
  <EuiFlexItem><EuiSwitch label={translate('no-expatriados')} checked={filtros.noExpatriados} onChange={()=>onChangeFilter({noExpatriados:!filtros.noExpatriados})}/></EuiFlexItem>
  ) : null

  const itemFilters = [
    <EuiFlexGroup direction='column'>
        {getFilterNoExpatriados()}
        <EuiFlexItem><EuiSwitch label={translate('expatriado-sin-configurar')} checked={filtros.expatriadosNoFacturables} onChange={()=>onChangeFilter({expatriadosNoFacturables:!filtros.expatriadosNoFacturables})}/></EuiFlexItem>
        <EuiFlexItem><EuiSwitch label={translate('expatriado-facturable')} checked={filtros.expatriadosFacturables} onChange={()=>onChangeFilter({expatriadosFacturables:!filtros.expatriadosFacturables})}/></EuiFlexItem>
    </EuiFlexGroup> 
  ]

  const buttonSave =(<EuiButton disabled={!acceptFilter} size='s' fullWidth fill color='primary' onClick={onSaveFilter}>{translate('filtrar')}</EuiButton>);

  const button = (<EuiButtonIcon iconType={'logstashFilter'} onClick={onButtonClick}></EuiButtonIcon>);

  return (
    <EuiPopover
      id={smallContextMenuPopoverId}
      button={button}
      isOpen={isPopoverOpen}
      closePopover={closePopover}
      panelPaddingSize="none"
      anchorPosition="downLeft"
    >
        <EuiPanel>
        {itemFilters}
        <EuiSpacer/>
        {buttonSave}
        </EuiPanel>
    </EuiPopover>
  );
};